webpackJsonp([80873460386452],{

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/delivery.3d3a574e.mp4";

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.frontmatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Article = __webpack_require__(13);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Block = __webpack_require__(5);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _Figure = __webpack_require__(10);
	
	var _Figure2 = _interopRequireDefault(_Figure);
	
	var _delivery = __webpack_require__(334);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var frontmatter = exports.frontmatter = {
	  id: 'delivery',
	  isWork: false,
	  subtitle: 'Delivery',
	  title: 'Share your design work,<br/>clutter-free.',
	  date: '2017-04-01',
	  cover: './delivery.png',
	  path: '/work/delivery',
	  excerpt: 'Around Easter 2017 I decided to work on a simple webapp called Delivery to help designers share their work in progress. I wanted to create a hassle\u2013free solution, which is reduced to the bare minimum of features and requires neither sign-up nor a credit card.',
	  details: [{
	    title: 'Responsibility',
	    description: 'Design & Development'
	  }, {
	    title: 'Date',
	    description: 'Q2 2017'
	  }, {
	    title: 'Technology',
	    description: 'React, Next.js, Node.js'
	  }]
	};
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Article2.default,
	    props,
	    _react2.default.createElement(
	      _Block2.default,
	      { mobilePull: true },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Around Easter 2017 I decided to work on a simple webapp called',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '//delivery.now.sh' },
	          'Delivery'
	        ),
	        ' to help designers share their work in progress.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'right' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'I wanted to create a hassle\u2013free solution, which is reduced to the bare minimum of features and requires neither sign-up nor a credit card.'
	      )
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'center', pull: true },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Features'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Type in your company/client, upload and describe your screens, then share with colleagues.\xA0Simple.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'center' },
	      _react2.default.createElement('video', { src: _delivery2.default, playsInline: true, autoPlay: true, loop: true, muted: true })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Goals'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I created Delivery mainly to sharpen my React & MobX skills. Building a simple, yet full webapp from the first line of code to deployment in a matter of roughly 3 days was a great experience.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I drew inspiration from makers like',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '//twitter.com/levelsio' },
	          'Pieter Levels'
	        ),
	        ' and their no-nonsense approach to launching new products & experiments early and often.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'right' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Technology'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The project is built on top of my',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '//github.com/fabe/www' },
	          'personal boilerplate'
	        ),
	        ', featuring React, MobX, Next.js and MongoDB. I am hosting the images on',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'caps' },
	          'AWS'
	        ),
	        ', and run the backend on a',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '//linode.com' },
	          'Linode'
	        ),
	        ' server.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The full source code is',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '//github.com/fabe/delivery' },
	          'available on GitHub'
	        ),
	        '.'
	      )
	    )
	  );
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-articles-delivery-index-js-8c3cdf75f56ab4046497.js